import { getLocationById as getLocationByIdOp } from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import { LocationNotFoundError } from '../../errors/location-errors'
import type { Location } from '../../types'

export interface GetLocationParams {
  id: number
  required?: boolean
  executor?: GqlExecutor
}

export async function getLocation(params: GetLocationParams): Promise<Location | null> {
  const location = (await getLocationByIdOp(
    { id: params.id },
    { executor: params.executor }
  )) as Location | null

  if (!location && params.required) {
    throw new LocationNotFoundError({ id: params.id })
  }

  return location ?? null
}
